(function () {
  function run() {
    var root = document.querySelector("[data-bbco-ycbm-confirmation]");
    if (!root) return;

    var p = new URLSearchParams(window.location.search);

    var fname = p.get("fname") || "";
    var lname = p.get("lname") || "";
    var name = (fname + " " + lname).trim();

    var ref = p.get("ref") || "";
    var when = p.get("when") || "";

    var ics = p.get("ics") || "";
    var gcal = p.get("gcal") || "";
    var reschedule = p.get("reschedule") || "";

    var rows = root.querySelector("#rows");
    var nameVal = root.querySelector("#nameVal");
    var whenVal = root.querySelector("#whenVal");
    var refVal = root.querySelector("#refVal");

    var rescheduleBtn = root.querySelector("#rescheduleBtn");
    var calendarBlock = root.querySelector("#calendarBlock");
    var gcalBtn = root.querySelector("#gcalBtn");
    var icsBtn = root.querySelector("#icsBtn");

    var scrollExpect = root.querySelector("#scrollExpect");
    var footnote = root.querySelector("#footnote");

    var hasAny = !!(name || ref || when);
    if (rows && hasAny) rows.style.display = "block";

    if (nameVal) nameVal.textContent = name || "Booked guest";
    if (whenVal) whenVal.textContent = when || "Saved";
    if (refVal) refVal.textContent = ref || "Saved";

    if (rescheduleBtn) {
      if (reschedule) {
        rescheduleBtn.style.display = "inline-flex";
        rescheduleBtn.href = reschedule;
      } else {
        rescheduleBtn.style.display = "none";
      }
    }

    if (calendarBlock) {
      if (gcal || ics) {
        calendarBlock.style.display = "flex";
        if (gcalBtn) {
          if (gcal) gcalBtn.href = gcal;
          else gcalBtn.style.display = "none";
        }
        if (icsBtn) {
          if (ics) icsBtn.href = ics;
          else icsBtn.style.display = "none";
        }
      } else {
        calendarBlock.style.display = "none";
      }
    }

    if (scrollExpect) {
      scrollExpect.addEventListener("click", function () {
        var el = document.getElementById("what-to-expect");
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
      });
    }

    if (footnote && !hasAny) {
      footnote.textContent =
        "If you booked via an embedded calendar, make sure YCBM is set to redirect the whole browser window, not only inside the embed.";
    }

    // Optional GTM event hook
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "ycbm_booking_confirmed",
      ycbm_ref: ref || null,
      ycbm_when: when || null
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", run);
  } else {
    run();
  }
})();
